import { Environment } from './environment.model';

export const environment: Environment = {
  envName: 'stage',
  apiUrl: 'https://y2q3h0gov8.execute-api.eu-north-1.amazonaws.com',
  useProxy: false,
  timeZone: 'Europe/Copenhagen',
  awsCognitoConfig: {
    identityPoolId: 'eu-north-1:3352c080-f73c-43ab-9531-90a601f95dd9',
    userPoolId: 'eu-north-1_mIH0flSC6',
    userPoolWebClientId: '6q6jvjg6jrlsl9b5pbr3h568lb',
    region: 'eu-north-1',
    mandatorySignIn: true,
    oauth: {
      domain: 'tv2-aci-stage.auth.eu-north-1.amazoncognito.com',
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: 'https://aci-interface.aws-aci.tv2api.stage.tv2dev.dk',
      redirectSignOut: 'https://aci-interface.aws-aci.tv2api.stage.tv2dev.dk',
      responseType: 'code',
    },
    headerXHostOverride: false,
    tokenRefreshCheckPeriod: 5000,
    tokenDurationSafeBufferFactor: 0.8,
  },
};
